/**
 * @file css class names for font
 */

enum FontNameToFontId {
  Inter = 1,
  Lora = 2,
  ComicNeueAngular = 3,
  AverageMono = 4,
  ShantellSans = 5,
  CourierPrime = 6,
}

function tailwindSurfaceFontClass(fontId: FontNameToFontId): string {
  switch (fontId) {
    case FontNameToFontId.Inter:
      return 'font-sans'
    case FontNameToFontId.Lora:
      return 'font-serif'
    case FontNameToFontId.ComicNeueAngular:
      return 'font-cursive'
    case FontNameToFontId.AverageMono:
      return 'font-padlet-monospace'
    case FontNameToFontId.ShantellSans:
      return 'font-shantell'
    case FontNameToFontId.CourierPrime:
      return 'font-courier'
    default:
      return 'font-sans'
  }
}

export { FontNameToFontId, tailwindSurfaceFontClass }
